import { useMemo } from "react";
import { useSelector } from "react-redux";
import { useMapContext } from "@evergis/react";

import { geometryToWkt } from "../../../hooks/geometrySelection/useGeometrySelectionConditions";
import { getGeometryFilter } from "../../../ducks/project/selectors";
import { useIsDashboard } from "../../../hooks/location/useIsDashboard";
import { useGeometrySelection } from "../../../hooks/geometrySelection/useGeometrySelection";

export const useEwktGeometry = () => {
  const { map } = useMapContext();
  const [{ history, type }] = useGeometrySelection();
  const geometryFilter = useSelector(getGeometryFilter);
  const isDashboard = useIsDashboard();

  return useMemo(
    () =>
      (!isDashboard || geometryFilter) && history.step > -1
        ? `SRID=${map?.crs?.wkid};${geometryToWkt(history.features[history.step], type, true)}`
        : "",
    [geometryFilter, history.features, history.step, isDashboard, map?.crs?.wkid, type],
  );
};
